import type { ChapterConfig } from './types'
import { commonTexts } from './common'
import { colors as brandColors } from '@/config/brands'

/**
 * FicMoon 品牌 - Chapter 页面配置
 */
export const chapterConfig: ChapterConfig = {
  texts: commonTexts,
  // themeDefaults: {
  //   background: '#292929', // 暗色主题
  //   size: '38', // 默认字体大小
  // },
  colors: {
    coinsGradient: 'linear-gradient( 180deg, #FFE9B8 0%, #FFF5E1 100%)',
    coinsPopupText1: '#AA4E0F',
    coinsPopupText2: '#FB552E',
    coinsPopupText3: '#AA4E0F',
    coinsPopupText4: '#FFFFFF',
    // 充值弹窗颜色配置
    vipBg: brandColors!.bg.card,
    subscribeActiveBg: '#2C2A28',
    purpleTextGradient: 'linear-gradient(90deg, rgba(215,164,94,0.7) 0%, rgba(94,74,53,0.6) 100%)',
    pinkGradient: 'linear-gradient( 90deg, #E93D56 0%, #FC5331 100%)',
    // 会员订阅背景图
    memberSubscribeBg: '/images/ficmoon/chapter/member_subscribe_bg.webp',
  },
}
